import type { CameraPlatformId } from '../../domain/camera-platform';

/** Describes the retained exports, including their authored camera settings. */
export const CAMERA_SAMPLE_DESCRIPTIONS: Record<CameraPlatformId, { platform: string; sample: string }> = {
  blackbird: {
    platform: 'Steady aerial tracking over monochrome satellite imagery.',
    sample: 'Keyframes hold a 45° tilt, 650 m altitude, and 50mm lens setting.',
  },
  'night-hawk': {
    platform: 'Monochrome sensor tracking with green telemetry.',
    sample: 'Keyframes add repeated turns, climbs, tilt changes, and cuts between lens settings.',
  },
  'aerial-follow': {
    platform: 'Follows the trace at a steady bearing, with a wide opening and finish.',
    sample: 'Keyframes hold a 55° tilt, 200 m altitude, and 50mm lens setting.',
  },
  chase: {
    platform: 'Follows behind the trace marker and turns with the route.',
    sample: 'Keyframes raise then lower the camera and change the lens setting from 200 to 400mm and back.',
  },
  orbit: {
    platform: 'Follows the trace at a steady bearing unless rotation is keyed.',
    sample: 'Keyframes add a full 360° turn and change the lens setting from 200 to 400mm and back.',
  },
  'terrain-reveal': {
    platform: 'Tracks beside the route, rises, and pulls back across the terrain.',
    sample: 'Keyframes change the tilt from 35° to 60° to 45° and the lens setting from 200 to 400mm and back.',
  },
  uav: {
    platform: 'Keeps the whole route in view as the trace advances.',
    sample: 'Keyframes add a gentle 35° turn and tilt the view from 38° to 45° and back.',
  },
};
